module.exports = __webpack_public_path__ + "static/media/materials_conversion.4c6a0377.png";